export const leiKonsolidaceTypSelect = [
    {
        labelcz: 'US GAAP',
        value: 'US_GAAP'
    },
    {
        labelcz: 'IFRS',
        value: 'IFRS'
    },
    {
        labelcz: 'UCETNISTANDARDY_JINE',
        value: 'OTHER_ACCOUNTING_STANDARD'
    }
];

export const leiKonsolidaceTypSelectAlt = [
    {
        labelcz: 'US GAAP',
        value: 'US_GAAP'
    },
    {
        labelcz: 'IFRS',
        value: 'IFRS'
    },
    {
        labelcz: 'GOVERNMENT ACCOUNTING STANDARD',
        value: 'GOVERNMENT_ACCOUNTING_STANDARD'
    },
    {
        labelcz: 'UCETNISTANDARDY_JINE',
        value: 'OTHER_ACCOUNTING_STANDARD'
    }
];

export const leiKonsolidaceTypSelectAltGov = [
    {
        labelcz: 'GOVERNMENT ACCOUNTING STANDARD',
        value: 'GOVERNMENT_ACCOUNTING_STANDARD'
    }
];
